/* eslint-disable react/jsx-no-target-blank */
import React, { Fragment, useState, useEffect } from "react";
import API from "@unisearch/helpers/api";
import { Grid, Skeleton } from "@mui/material";

import {
  getAssets,
  htmlParse,
  isEmpty,
  countryNameHelper,
} from "@unisearch/helpers";
import { DownloadGuide } from "@unisearch/common";
import styles from "./study_overview_about.module.scss";
import Image from "next/legacy/image";
import Advertisement from "@unisearch/common/advertisement";
import AdvertisementRow from "@unisearch/common/advertisement/row";

export const StudyOverviewAbout = ({ countryInfo, pageData }) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const arr = ["united-states", "united-kingdom"];
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await API.get(`/public/country/info/${countryInfo?.slug}`);
        setLoading(false);
        setData(res.data);
      } catch (error) {
        setLoading(false);
        setError("Something went wrong");
      }
    };
    fetchData();
  }, [countryInfo?.slug]);

  const LoadingComponent = () => (
    <>
      <Skeleton
        variant="rectangular"
        width="30%"
        height={30}
        sx={{ margin: "10px auto" }}
      />
      {new Array(4).fill(1).map((_, i) => {
        return (
          <Skeleton
            key={i}
            variant="rectangular"
            width="100%"
            height={20}
            sx={{ margin: "10px 0px" }}
          />
        );
      })}

      <Grid container spacing={2} alignItems={"center"}>
        {new Array(8).fill(1).map((_, i) => {
          return (
            <Grid item xs={12} sm={12} md={4} lg={3} key={i}>
              <Skeleton variant="rectangular" width="100%" height={150} />
            </Grid>
          );
        })}
      </Grid>
    </>
  );

  return (
    <Fragment>
      {isEmpty(data) ? (
        <></>
      ) : (
        <section>
          <div className={`container`}>
            {loading ? (
              <LoadingComponent />
            ) : (
              <>
                <div className={styles.heading}>
                  <h2>
                    About the Country{" "}
                    {countryInfo?.name ? (
                      <>({countryNameHelper(countryInfo)})</>
                    ) : (
                      ""
                    )}
                  </h2>

                  {data?.description && (
                    <div
                      className={`${styles.country_description} from_texteditor_wrapper `}
                    >
                      {htmlParse(data?.description)}
                    </div>
                  )}
                  {pageData && pageData?.guidepdf && (
                    <div className={`${styles.btn_wrapper} mb-8`}>
                      <DownloadGuide
                        customClasses={{ root: "btn-bg" }}
                        fileSrc={pageData?.guidepdf?.src}
                        fileName={
                          pageData?.guidepdf?.mediaName || "Country brochure"
                        }
                        documentId={parseInt(
                          pageData?.guidepdf?.mediaManagerId
                        )}
                        documentType="countryguide"
                      />
                    </div>
                  )}
                </div>

                {process.env.NEXT_PUBLIC_COMPONENT_ISHIDDEN !== "true" && (
                  <AdvertisementRow />
                )}

                <div className={styles.about}>
                  <ul className={styles.about_facts}>
                    <li>
                      <Image
                        width={70}
                        height={70}
                        src={getAssets("/assets/images/study/capital.webp")}
                        alt="Capital"
                      />
                      <span className={styles.first}>Capital</span>
                      <span className={styles.last}>{data?.capital}</span>
                    </li>
                    <li>
                      <Image
                        width={70}
                        height={70}
                        src={getAssets("/assets/images/study/population.webp")}
                        alt="Population"
                      />
                      <span className={styles.first}>Population</span>
                      <span className={styles.last}>{data?.population} Mn</span>
                    </li>
                    <li>
                      <Image
                        width={70}
                        height={70}
                        src={getAssets("/assets/images/study/language.webp")}
                        alt="Language"
                      />
                      <span className={styles.first}>Language</span>
                      <span className={styles.last}>{data?.language}</span>
                    </li>
                    <li>
                      <Image
                        width={70}
                        height={70}
                        src={getAssets(
                          "/assets/images/study/international-study.webp"
                        )}
                        alt="International Students"
                      />
                      <span className={styles.first}>
                        International Students
                      </span>
                      <span className={styles.last}>{data?.intStudent}</span>
                    </li>
                    <li>
                      <Image
                        width={70}
                        height={70}
                        src={getAssets("/assets/images/study/GDP.webp")}
                        alt="GDP"
                      />
                      <span className={styles.first}>GDP</span>
                      <span className={styles.last}>
                        {data?.currencySymbol}
                        {data?.gdp} Trillion
                      </span>
                    </li>
                    <li>
                      <Image
                        width={70}
                        height={70}
                        src={getAssets("/assets/images/study/click.webp")}
                        alt="Dialing Code"
                      />
                      <span className={styles.first}>Dialing Code</span>
                      <span className={styles.last}>{data?.phoneCode}</span>
                    </li>
                    <li>
                      <Image
                        width={70}
                        height={70}
                        src={getAssets("/assets/images/study/money.webp")}
                        alt="Currency"
                      />
                      <span className={styles.first}>Currency</span>
                      <span className={styles.last}>{data?.currency}</span>
                    </li>
                    <li>
                      <Image
                        width={70}
                        height={70}
                        src={getAssets("/assets/images/study/university.webp")}
                        alt="Universities"
                      />
                      <span className={styles.first}>Universities</span>
                      <span className={styles.last}>
                        {data?.noOfUniversity}
                      </span>
                    </li>
                  </ul>
                </div>
              </>
            )}
          </div>
        </section>
      )}
    </Fragment>
  );
};

export default StudyOverviewAbout;
